import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

import _ from 'lodash';

export type PaginatedResults<T> = {
  page: number;
  pageSize: number;
  total: number;
  total_pages: number;
  data: T[];
};

export function paginate<T>(
  items: T[],
  page: number = 1,
  pageSize: number = 12
): PaginatedResults<T> {
  const offset = (page - 1) * pageSize;
  const pagedItems = _.drop(items, offset).slice(0, pageSize);
  return {
    page: page,
    pageSize: pageSize,
    total: items.length,
    total_pages: Math.ceil(items.length / pageSize),
    data: pagedItems
  };
}

export function useItemOrRedirect<T>() {
  const navigate = useNavigate();
  const item = useLocation().state as T;
  useEffect(() => {
    if (!item) {
      navigate(-1);
    }
  }, [item]);
  return item;
}

export function useSwalLoading(isLoading: boolean) {
  useEffect(() => {
    if (isLoading) {
      Swal.showLoading();
    } else {
      Swal.hideLoading();
      Swal.close();
    }
  }, [isLoading]);
  return null;
}
